<template>
    <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
        <div v-show="show" class="inline-block align-bottom rounded-lg text-left overflow-hidden transform transition-all sm:my-8 sm:align-middle sm:max-w-sm w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <h1 class="text-2xl font-bold text-white mb-4 text-left">
                You have multiple accounts with {{ $parent.consumerPortalName }}. Please choose an account below.
            </h1>
            <div v-show="show"
                 v-for="(account, i) in accounts"
                 :class="{ 'mb-6 md:mb-8 lg:mb-10': accounts && (i+1) !== accounts.length }"
                 class="bg-white rounded-lg p-4 text-left shadow-xl">
                <h6 v-if="account" class="text-xs font-medium text-gray-400 text-left mb-4">
                    Reference ID: {{ account.id }}
                </h6>

                <h6 class="text-sm font-medium text-center mb-1">
                    Remaining Balance
                </h6>
                <h1 class="text-3xl font-bold mb-4 text-center">
                    <template v-if="account.financial">
                        {{ account.financial.current_balance | money }}
                    </template>
                    <template v-else>
                        {{ account.current_balance | money }}
                    </template>
                </h1>

                <div class="divide-solid divide-y divide-gray-200">
                    <div class="flex justify-between text-sm pb-3">
                        <div class="flex-none w-1/2">
                            Lender
                        </div>
                        <div class="flex-initial font-semibold text-right">
                            <template v-if="account.financial">
                                {{ account.financial.lender }}
                            </template>
                            <template v-else>
                                {{ account.lender }}
                            </template>
                        </div>
                    </div>

                    <div class="flex justify-between text-sm pt-3 mb-4">
                        <div class="flex-initial">
                            Charge Off Date
                        </div>
                        <div class="flex-initial font-semibold">
                            <template v-if="account.financial">
                                {{ account.financial.charge_off_date | moment('MM/DD/YYYY') }}
                            </template>
                            <template v-else>
                                {{ account.charge_off_date | moment('MM/DD/YYYY') }}
                            </template>
                        </div>
                    </div>
                </div>

                <button @click="$emit('select', account)" :class="`w-full justify-center text-black items-center inline-flex items-center text-sm py-2 border border-transparent shadow-sm leading-4 font-medium rounded-md bg-${$root.theme}-300 hover:bg-${$root.theme}-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${$root.theme}-200`">
                    <i class="fa fa-check fa-fw"></i>&nbsp;
                    <template v-if="account.financial">
                        View this Account
                    </template>
                    <template v-else>
                        Select Account
                    </template>
                </button>
            </div>

            <button v-if="withClose" @click="$emit('close')" class="mt-6 w-full justify-center text-black items-center inline-flex items-center py-3 border border-transparent shadow-sm leading-4 font-medium rounded-md bg-gray-300 hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200">
                Close
            </button>
        </div>
    </transition>
</template>

<script>
    export default {
        props: ['show', 'accounts', 'with-close']
    }
</script>